import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postContracts({ body }) {
  return BaseService.post(REST.CONTRACTS, body);
}

function putContracts({ body, id }) {
  return BaseService.put(REST.CONTRACTS_ID(id), body);
}

function getContracts(params) {
  return BaseService.get(REST.CONTRACTS, {
    params: paramsFilter({ params }),
  });
}

function getContractsChargeApproval({ params, id }) {
  return BaseService.get(REST.CONTRACT_CHARGE_APPROVAL(id), {
    params,
  });
}

function deleteContracts({ id }) {
  return BaseService.delete(REST.CONTRACTS_ID(id));
}

function postContractsWorkOrder({ body }) {
  return BaseService.post(REST.CONTRACT_WORK_ORDER, body);
}

export default {
  getContracts,
  postContracts,
  deleteContracts,
  putContracts,
  postContractsWorkOrder,
  getContractsChargeApproval,
};
